<template>
    <div
        class="relative h-full"
    >
        <page-header
            :show-submit-button="false"

            :can-delete="!data.usage.length"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="false"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <rocket-table
            :language="data.language"
            :disabled="true"
            :value="data"
        />

        <div
            v-if="data.usage.length"
            class="border bg-white dark:bg-gray-700 text-black dark:text-white rounded-lg shadow p-4 mt-3"
        >
            <h3 class="mb-3">Usages</h3>
            <ul>
                <li v-for="document in data.usage">
                    <a :href="document.edit_route">
                        {{ document.edit_route }}
                        <span v-if="document.path.length"> => ( {{ document.path.join(', ') }} )</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import crudForm from "../mixins/crudForm";
import RocketTable from "./TableElement/RocketTable.vue";
export default {
    name: "TableForm",
    components: {RocketTable},
    mixins: [crudForm],
    data() {
        return {

        };
    },
};
</script>
